
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MstMemDeliveryVO } from '@/views/biz/mypage/vo/mypage.vo'
import CommonPopup from '../../../components/CommonPopup.vue'
import DaumPostcode from 'vuejs-daum-postcode'

@Component({
  components: {DaumPostcode}
})
export default class AddressSearchPop extends CommonPopup {
  @Prop() address!: MstMemDeliveryVO;

  // 선택
  choice(data): void {
    this.$emit('update:opened', false);
    this.address.addr = data.buildingName? data.address +" "+ "("+data.buildingName+")" : data.address;
    this.address.addrBldCd = data.buildingCode;
    this.address.addrType = data.userSelectedType == 'R' ? '01': '02';
    this.address.postNo = data.zonecode;

    this.$emit('update:address', this.address);
  }

  // init
  @Watch('opened') onOpened(): void{
    if(!this.opened) {
      return;
    }
    window.scrollTo(0,0);
  }  
}
